import { ENV } from '../../config/runtimeEnv';

import { PatientResourceLink } from "../../types/file/ResourceLinkTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_FILE_SERVER;

export const getPatientResourceLinks = async (patientId: UserUuid) => {
		try {
				const response = await http.get(`${API_BASE_URL}/patient-resource-links/patient/${patientId}`);
				return response.data;
		} catch (error) {
				throw new Error(`Error fetching patient resource links: ${error}`);
		}
}

// NOTE: the form-submitting calls (create / update / assign) deliberately do NOT wrap the axios
// error. The file service now returns request-validation failures as 422 with a
// { message, errors: { field: [...] } } body; the consuming modal runs that through
// extractValidationErrors() to surface the per-field messages. Wrapping in `new Error(...)` would
// flatten the response away and the user would only ever see a generic failure.
export const createPatientResourceLink = async (linkData: PatientResourceLink) => {
		const response = await http.post(`${API_BASE_URL}/patient-resource-links`, linkData);
		return response.data;
}

export const updatePatientResourceLink = async (linkData: PatientResourceLink) => {
		const response = await http.put(`${API_BASE_URL}/patient-resource-links/${linkData.id}`, linkData);
		return response.data;
}

export const deletePatientResourceLink = async (linkId: number) => {
		try {
				const response = await http.delete(`${API_BASE_URL}/patient-resource-links/${linkId}`);
				return response.data;
		} catch (error) {
				throw new Error(`Error deleting patient resource link: ${error}`);
		}
}

export const getGlobalResourceLinks = async () => {
		try {
				const response = await http.get(`${API_BASE_URL}/patient-resource-links/global`);
				return response.data;
		}
		catch (error) {
				throw new Error(`Error fetching global resource links: ${error}`);
		}
}


export const assignGlobalResourceLinksToPatient = async (companyId: number, patientId: UserUuid, resourceId: number) => {
		const response = await http.post(`${API_BASE_URL}/patient-resource-links/global/assign`, {
				company_id: companyId,
				patient_id: patientId,
				link_id: resourceId,
		});
		return response.data;
}
